// ─── Arabic UI text ─────────────────────────────────────────────────────────
// Kept deliberately SHORT and SIMPLE: the target user reads very little.
// The UI leans on color + icons + big numbers; text is a secondary cue.

export const t = {
    appName: "ماسح الطلبات",
    scanHere: "امسح الطلب هنا",
    scanPrompt: "امسح الطلب",
    scanSub: "وجّه الماسح نحو الباركود",
    searching: "جارٍ البحث…",

    // Verdicts
    goTitle: "جاهز — أرسل",
    goSub: "كل المنتجات جاهزة للشحن",
    stopTitle: "توقف — لا ترسل",
    stopSub: "هذا الطلب ليس جاهزاً",
    cautionTitle: "انتبه — أرسل الأخضر فقط",
    cautionSub: "بعض المنتجات فقط جاهزة",
    notFoundTitle: "الطلب غير موجود",
    notFoundSub: "أعد المسح",
    badFormat: "رقم غير صحيح — أعد المسح",
    networkError: "لا يوجد اتصال — أعد المحاولة",

    // Counters
    products: "منتجات",
    pieces: "قطع",
    order: "طلب",
    store: "متجر",

    // Product card
    pack: "أرسل",
    dontPack: "لا ترسل",
    sku: "الرمز",
    details: "تفاصيل",
    price: "الثمن",
    tracking: "رقم التتبع",
    trackLink: "تتبّع الشحنة",
    productPage: "افتح صفحة المنتج على جوميا",
    packingDoneError: "تعذّر حفظ علامة «تم» — تحقق من الاتصال وأعد المحاولة",
    shipment: "طريقة الشحن",
    createdAt: "تاريخ الطلب",
    updatedAt: "آخر تحديث",
    reason: "السبب",

    // Packing view (تجهيز الطلبات)
    packMode: "التجهيز",
    scanMode: "المسح",
    packingTitle: "تجهيز الطلبات",
    productsTab: "المنتجات",
    ordersTab: "الطلبات",
    refresh: "تحديث",
    emptyRts: "لا توجد طلبات جاهزة الآن 🎉",
    packingLoadError: "تعذر التحميل — اضغط تحديث",
    take: "خذ",
    fromStore: "المتجر",
    doneBtn: "تم ✓",
    undoBtn: "إرجاع",
    packedLabel: "تم التجهيز",
    remainingLabel: "لم يجهز بعد",
    tapToZoom: "اضغط على الصورة للتكبير",
    ordersWord: "طلبات",
    piecesWord: "قطع",
    productsWord: "منتجات",
    orderDate: "تاريخ الطلب",
    timeTab: "الوقت",
    todayWord: "اليوم",
    yesterdayWord: "أمس",
    startHere: "ابدأ هنا — الأقدم",
    newBadge: "جديد",
    oldBadge: "قديم — أرسله أولاً",
    veryOldBadge: "قديم جداً — أرسله اليوم!",
    oldTile: "قديمة",
    allTaken: "تم أخذ الكل",
    takenSoFar: "تم أخذها",

    // Orders on hold ("cannot prepare it now")
    holdBtn: "لا يمكن تجهيزه الآن",
    holdTitle: "لماذا لا يمكن تجهيزه؟",
    reasonNoStock: "غير موجود في المخزن",
    reasonDamaged: "الطرد تالف",
    reasonNotFound: "لم أجده",
    reasonOther: "سبب آخر",
    holdCancel: "إلغاء",
    heldBadge: "في الانتظار",
    heldTile: "في الانتظار",
    heldSectionTitle: "طلبات في الانتظار — لن تُطبع ملصقاتها حتى تُجهَّز",
    heldSince: "منذ",
    heldNotified: "تم إبلاغ المسؤول",
    releaseBtn: "وصل المنتج — جهّزه الآن",
    holdError: "تعذر الحفظ — أعد المحاولة",
    labelsHeldNote: "الطلبات في الانتظار لن تُطبع",

    // "Print the labels" (send RTS shipping labels to the printing mailbox)
    labelsBtn: "جهّزنا كل الطلبات — أرسل ملصقات الشحن للطباعة",
    labelsBtnSub: "اضغط فقط بعد تجهيز وتغليف كل الطلبات",
    labelsTitle: "إرسال ملصقات الشحن",
    labelsConfirm: "هل انتهيت من تجهيز كل الطلبات؟ سيتم إرسال ملصقات الشحن إلى البريد لطباعتها ولصقها على الطرود.",
    labelsRemainingWarn: "انتبه: هناك طلبات لم تُعلَّم «تم ✓» بعد",
    labelsYes: "نعم، أرسل الملصقات",
    labelsNo: "لا، لم أنتهِ بعد",
    labelsSending: "جارٍ تجهيز الملصقات وإرسالها… لا تغلق الصفحة",
    labelsBusy: "الإرسال جارٍ بالفعل — انتظر",
    labelsDone: "تم الإرسال ✅ — اطبع الملصقات من البريد",
    labelsNothing: "لا توجد ملصقات جديدة للطباعة",
    labelsFailed: "لم يتم الإرسال — أخبر المسؤول",
    labelsTimeout: "يستغرق وقتاً أطول من المعتاد — تحقق من البريد بعد قليل",
    labelsLastRun: "آخر إرسال",
    outcomeSent: "أُرسلت ✅",
    outcomeNothing: "لا شيء للطباعة",
    outcomeNoEmail: "لا يوجد بريد — أخبر المسؤول",
    outcomeToken: "انتهت صلاحية الدخول — أخبر المسؤول",
    outcomeError: "خطأ — أخبر المسؤول",

    // Warehouse locations
    findMode: "أين؟",
    findTitle: "أين المنتج؟",
    findPlaceholder: "اكتب الرمز أو اسم المنتج",
    findHint: "امسح باركود المنتج أو اكتب اسمه",
    findEmpty: "لا يوجد منتج بهذا الاسم",
    findError: "تعذر البحث — أعد المحاولة",
    locationWord: "المكان",
    locationHint: "المكان = الحرف + الرقم على الرف",
    noLocation: "بدون مكان — اسأل المسؤول",
    overflowWord: "مكان إضافي",
    sortByPlace: "رتّب حسب المكان",
    sortByTime: "رتّب حسب الوقت",
    sortBySize: "رتّب حسب الحجم",
    sortByQty: "رتّب حسب الكمية",
    stockWord: "المخزون",
    // Warehouse stock hint (NOT the quantity to pick)
    stockIn: "في المخزن",
    stockAvailable: "موجود في المخزن",
    stockOnly: "فقط",
    stockEmpty: "المخزن فارغ — اطلب من الدار البيضاء",
    stockLow: "لا يكفي — اطلب من الدار البيضاء",
    stockUnknown: "المخزون غير مسجّل",
    stockHint: "🏬 = هل المنتج موجود في المخزن بالكمية المطلوبة",
    sizeWord: "الحجم",
    placeGuide: "الرمز = الممر + الرف - الطابق",

    // ── Marjan preparation (separate flow: verify pieces BEFORE confirming on Marjane) ──
    marjanMode: "مرجان",
    marjanTitle: "تجهيز طلبات مرجان",
    marjanRule: "تحقق من كل القطع أولاً — لا تؤكد ولا تطبع على مرجان قبل أن تكون كل القطع في يدك",
    marjanRuleSub: "إذا أُكِّد الطلب وطُبع ثم نقصت قطعة، مرجان يلغي الطلب فوراً",
    marjanEmpty: "لا توجد طلبات مرجان الآن 🎉",
    marjanLoadError: "تعذر التحميل — اضغط تحديث",
    marjanSaveError: "تعذر الحفظ — أعد المحاولة",
    marjanToCheckTile: "للتحقق",
    marjanReadyTile: "جاهزة",
    marjanMissingTile: "ناقصة",
    marjanConfirmedTile: "مؤكدة على مرجان",
    marjanSectionCheck: "طلبات للتحقق — ابدأ هنا",
    marjanSectionReady: "جاهزة ✅ — يمكن للمكتب تأكيدها وطباعتها على مرجان",
    marjanSectionMissing: "ناقصة ❌ — لا تؤكد على مرجان",
    marjanSectionPrepared: "مؤكدة على مرجان 📄 — في انتظار الاستلام",
    marjanAllPresentBtn: "كل القطع موجودة ✅",
    marjanMissingBtn: "قطعة ناقصة ❌",
    marjanMissingTitle: "ما المشكلة؟",
    marjanRecheckBtn: "وصلت القطعة — تحقق من جديد",
    marjanUndoBtn: "إرجاع",
    marjanReadyHint: "جاهز — أخبر المكتب ليؤكد ويطبع على مرجان",
    marjanMissingHint: "لا تؤكد على مرجان — تم إبلاغ المسؤول",
    marjanPreparedHint: "تم التأكيد على مرجان — احفظ الطرد جاهزاً للاستلام",
    marjanDeliverBy: "التسليم قبل",
    marjanCity: "المدينة",
    marjanNotLinked: "غير مربوط بالمخزن — اسأل المسؤول",
    marjanStatusWord: "حالة مرجان",
    marjanPickHint: "خذ القطع من الرف للطلبات التي لم تُحقَّق بعد",
    marjanLastUpdate: "آخر تحديث",
    marjanPrintedTile: "للتسليم لمرجان",
    marjanReceivedTile: "استلمها مرجان",
    marjanSectionPrinted: "مطبوعة 🖨️ — سلّم الطرود لمرجان الآن",
    marjanSectionReceived: "استلمها مرجان ✅ — وصلت إلى مستودع مرجان",
    marjanPrintedHint: "تم طبع الوثائق — الطرد ما زال عندنا حتى يسجّله مرجان",
    marjanReceivedHint: "سجّلها مرجان عنده — انتهى دورنا",
    marjanPrintedSince: "طُبعت",
    marjanReceivedSince: "استُلمت",
    marjanPieceCheck: "في يدي؟",
    marjanPieceChecked: "في يدي",
    marjanTickFirst: "علّم كل قطعة أولاً",
    marjanConfirmQuestion: "هل كل القطع في يدك الآن؟",
    marjanConfirmYes: "نعم، كلها موجودة ✅",
    marjanConfirmNo: "لا، ارجع",

    // Returns scan (المرتجعات)
    retMode: "مرتجعات",
    retTitle: "استلام المرتجعات",
    retHint: "امسح رقم التتبع أو رقم الطلب على الطرد الراجع",
    retPlaceholder: "امسح الطرد أو اكتب رقم الطلب",
    retNotFound: "غير موجود في قائمة المرتجعات — أخبر المسؤول",
    retFound: "وجدته. ما حالة القطعة؟",
    retCondition: "ما حالة القطعة؟",
    retOk: "سليمة",
    retDamaged: "تالفة",
    retWrong: "قطعة أخرى",
    retIncomplete: "ناقصة",
    retSaved: "تم تسجيل الاستلام",
    retSaveError: "تعذر الحفظ — أعد المحاولة",
    retAlready: "هذا الطرد مسجّل كمستلَم من قبل",
    retReceivedBadge: "مستلَم",
    retOpenBadge: "لم يُستلم بعد",
    retScannedCode: "الرمز الممسوح",
    retHanded: "سلّمها المتجر لمندوبنا يوم",
    retWhere: "أين أنت الآن؟",
    retModeHub: "في مركز جوميا / مرجان — أستلم الطرود",
    retModeWarehouse: "في المستودع — وصلت الطرود",
    retPickerCode: "اسمك أو رمزك (مرة واحدة)",
    retHubHint: "امسح كل طرد يسلّمه لك المركز الآن",
    retCollected: "تم تسجيل الاستلام من المركز",
    retCollectedBadge: "استلمه المندوب",
    retAlreadyCollected: "هذا الطرد مسجّل كمستلَم من المركز من قبل",
    retAtPlatform: "لا يوجد تسجيل تسليم من المتجر بعد",
    retPick: "عدة مرتجعات لنفس المنتج — اضغط على الطلب المكتوب على الطرد",
    retPickHint: "الأفضل: امسح رمز الطرد (REP…) أو رقم الجولة من تقرير التسليم",
    retPicked: "الطرد المختار",
    retLinked: "نفس القطعة في طلب",
    retOpened: "فُتح من مسح الطرد — لم يسجّل المتجر هذا المرتجع بعد",
    retOpenCount: (n: number) => `${n} مرتجعات مفتوحة لهذا المنتج`,

    // 🚨 Hand-over alerts: handed to Jumia / Marjane, cancelled right after
    alertMode: "تنبيهات",
    alertTitle: "طرود سُلّمت ثم أُلغيت",
    alertHint: "سلّمنا الطرد لجوميا أو مرجان، وأُلغي الطلب في نفس اليوم. الطرد يجب أن يرجع إلينا.",
    alertNone: "لا توجد تنبيهات ✅",
    alertNotBack: "لم يرجع بعد",
    alertBack: "رجع للمخزن",
    alertCritical: "أُلغي قبل أن يستلمه مرجان",
    alertAfterScan: "أُلغي بعد ما سلّمناه (خرج من عندنا)",
    alertNoScan: "أُلغي عند التسليم",
    alertJumiaFast: "رجع بسرعة بعد التسليم",
    alertHanded: "سُلّم",
    alertCancelled: "أُلغي",
    alertPrinted: "طُبع",
    alertReason: "السبب",
    alertValue: "القيمة",
    alertSummary: (n: number, v: number) => `${n} طرود لم ترجع · ${v} درهم`,
    alertCriticalCount: (n: number) => `${n} أُلغيت بعد ما سلّمناها`,
    alertFilterOpen: "لم ترجع",
    alertFilterAll: "الكل",

    retEanWarning: "هذا باركود المنتج (EAN) — نفسه لكل قطعة من هذا المنتج. لتحديد الطرد بدقة: امسح رمز الطرد (REP…) أو رقم الجولة من تقرير التسليم ثم الـEAN",
    retRound: "جولة التسليم",
    retRoundHint: "الآن امسح باركود كل طرد (EAN) — يُبحث داخل هذه الجولة فقط",
    retRoundClear: "إنهاء الجولة",
    retReceivedOnes: (n: number) => `مستلمة من قبل: ${n}`,
    retNoOpenForProduct: "لا يوجد مرتجع مفتوح لهذا المنتج — امسح رمز الطرد (REP…) أو رقم الجولة من تقرير التسليم",

    // Header / admin
    sound: "الصوت",
    manageStores: "المتاجر",
    noStores: "لا توجد متاجر",
    storesReadOnly: "للعرض فقط — الإضافة والحذف من لوحة التحكم",
    delete: "حذف",
    addStore: "+ إضافة متجر",
    addStoreTitle: "إضافة متجر",
    storeName: "اسم المتجر",
    userId: "معرّف المستخدم",
    apiKey: "مفتاح API",
    cancel: "إلغاء",
    add: "إضافة",
};

// Jumia item statuses → short Arabic the worker understands at a glance.
const STATUS_AR: Record<string, string> = {
    READY_TO_SHIP: "جاهز للشحن",
    PENDING: "غير جاهز بعد",
    SHIPPED: "تم شحنه من قبل",
    DELIVERED: "تم توصيله من قبل",
    CANCELED: "ملغى",
    CANCELLED: "ملغى",
    RETURNED: "مرتجع",
    FAILED: "فشل التوصيل",
};

export const statusAr = (status: string) => STATUS_AR[status] || status;

// Arabic has singular / dual / plural(3-10) / plural(11+) forms.
export const countProducts = (n: number) => {
    if (n === 1) return "منتج واحد";
    if (n === 2) return "منتجان";
    if (n <= 10) return `${n} منتجات`;
    return `${n} منتج`;
};

export const countPieces = (n: number) => {
    if (n === 1) return "قطعة واحدة";
    if (n === 2) return "قطعتان";
    if (n <= 10) return `${n} قطع`;
    return `${n} قطعة`;
};

export const countOrders = (n: number) => {
    if (n === 1) return "طلب واحد";
    if (n === 2) return "طلبان";
    if (n <= 10) return `${n} طلبات`;
    return `${n} طلب`;
};

export const newOrdersMsg = (n: number) => {
    if (n === 1) return "وصل طلب جديد";
    if (n === 2) return "وصل طلبان جديدان";
    if (n <= 10) return `وصلت ${n} طلبات جديدة`;
    return `وصل ${n} طلب جديد`;
};

// "How long ago" in simple Arabic — the age of an order at a glance.
export const ageAr = (date: string | Date, now = Date.now()) => {
    const ms = now - new Date(date).getTime();
    if (!isFinite(ms) || ms < 0) return "الآن";
    const h = Math.floor(ms / 3600000);
    if (h < 1) return "الآن";
    if (h === 1) return "منذ ساعة";
    if (h === 2) return "منذ ساعتين";
    if (h <= 10) return `منذ ${h} ساعات`;
    if (h < 24) return `منذ ${h} ساعة`;
    const d = Math.floor(h / 24);
    if (d === 1) return "منذ يوم";
    if (d === 2) return "منذ يومين";
    if (d <= 10) return `منذ ${d} أيام`;
    return `منذ ${d} يوم`;
};

// Age → urgency bucket for coloring: fresh (<24h), old (24–48h), critical (≥48h)
export const ageLevel = (date: string | Date, now = Date.now()): "fresh" | "old" | "critical" => {
    const h = (now - new Date(date).getTime()) / 3600000;
    if (h >= 48) return "critical";
    if (h >= 24) return "old";
    return "fresh";
};

// Hold reason → Arabic
export const holdReasonAr = (r?: string | null) => {
    switch (r) {
        case "no_stock": return t.reasonNoStock;
        case "damaged": return t.reasonDamaged;
        case "not_found": return t.reasonNotFound;
        default: return t.reasonOther;
    }
};

// Size class → short Arabic hint for the worker
export const sizeAr = (s?: string | null) => {
    switch (s) {
        case "S": return "صغير";
        case "M": return "متوسط";
        case "L": return "كبير";
        case "XL": return "كبير جداً — الحيط";
        case "XXL": return "ضخم — الحيط، شخصان";
        default: return "";
    }
};

// Zone (from the slot code's zone) → Arabic
export const zoneAr = (z?: string | null) => {
    switch (z) {
        case "FAST": return "الرفوف القريبة";
        case "MEDIUM": return "الرفوف الوسطى";
        case "SLOW": return "الرفوف البعيدة";
        case "BULK": return "الحيط — BULK";
        case "RETURNS": return "المرتجعات";
        case "PACKING": return "طاولة التجهيز";
        default: return "";
    }
};
